const actions = "dibaz1amv";
const dropdownActions = "dibd1rx78m5";

export { actions, dropdownActions };
import "./actions.style.linaria.module.css";
//# sourceMappingURL=actions.style.js.map
